import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Layout, Button, Spin, Descriptions, Tag, Divider, Empty } from 'antd';
import { EditFilled } from '@ant-design/icons';
import { get } from '../redux/actions/alquilerActions';
import { getAllByParent } from '../redux/actions/contratoActions';
import AlquilerEditor from './AlquilerEditor';
import ContratoList from './ContratoList';
import ContratoViewer from './ContratoViewer';
import ContratoEditor from './ContratoEditor';
import { callStatus } from '../utils/constants';
import { withRouter } from 'react-router-dom';
import { setBreadcrumbTitle } from '../redux/actions/uiActions';
import CustomCellRender from './base/CustomCellRender';

const { Header, Content } = Layout;

const AlquilerViewer = ({
  dispatch,
  stateData,
  match: {
    params: { id, id2 },
  },
  location,
  history,
  contratoList,
}) => {
  const [showEdit, setShowEdit] = useState(false);
  const [showContratoEdit, setShowContratoEdit] = useState(false);

  const handleHideEditor = () => {
    setShowEdit(false);
  };

  useEffect(() => {
    if (String(stateData.object.data?.id) !== String(id2)) {
      dispatch(get(id2));
    }
    dispatch(getAllByParent(id2));
    // eslint-disable-next-line
  }, [id2, dispatch]);

  useEffect(() => {
    if (
      stateData.object.status === callStatus.OBJECT_SUCCESS ||
      stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS
    ) {
      const data = stateData.object.data;
      dispatch(
        setBreadcrumbTitle(
          `/campanas/${id}/alquileres/${id2}`,
          `${data.numero}`
        )
      );
    }
  }, [stateData.object.status, stateData.object.data, dispatch, id, id2]);

  const data = stateData.object.data;
  const loading = stateData.object.status === callStatus.OBJECT_IN_PROCESS;

  return (
    <Layout style={{ height: '100%' }}>
      <Header
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          marginTop: '5px',
          marginBottom: '10px',
          height: 'auto',
          minHeight: '50px',
          backgroundColor: 'transparent',
          padding: 0,
        }}
      >
        <Spin spinning={loading}>
          {data ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                height: '100%',
                width: '100%',
              }}
            >
              <Descriptions
                bordered
                size="small"
                column={4}
                style={{ marginBottom: 20, flex: 1, marginRight: 20 }}
              >
                <Descriptions.Item label="Número">
                  {data.numero}
                </Descriptions.Item>
                <Descriptions.Item label="Superficie Ha">
                  <CustomCellRender
                    text={data.superficie}
                    justify={'flex-start'}
                    prefix={''}
                  />
                </Descriptions.Item>
                <Descriptions.Item label="Modalidad de contrato" span={2}>
                  {data.contrato_unico ? (
                    <Tag color="cyan">Contrato Único</Tag>
                  ) : (
                    <Tag color="purple">Multicontrato</Tag>
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Propietarios" span={4}>
                  {data.alquiler_propietarios &&
                  data.alquiler_propietarios.length > 0
                    ? data.alquiler_propietarios.map((tag, index) => (
                        <Tag color="green" key={`prop-${index}`}>
                          {tag.propietario_nombre}
                        </Tag>
                      ))
                    : ''}
                </Descriptions.Item>
                <Descriptions.Item label="Actividades" span={4}>
                  {data.alquiler_actividades &&
                  data.alquiler_actividades.length > 0
                    ? data.alquiler_actividades.map((tag, index) => (
                        <Tag color="geekblue" key={`act-${index}`}>
                          {tag.establecimiento_nombre} / {tag.cultivo_nombre}
                        </Tag>
                      ))
                    : ''}
                </Descriptions.Item>
              </Descriptions>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <Button
                  icon={<EditFilled />}
                  onClick={() => setShowEdit(true)}
                  type="primary"
                  size="small"
                >
                  Editar
                </Button>
                {!!data.contrato_unico &&
                  (!contratoList || contratoList.length === 0) && (
                    <Button
                      onClick={() => setShowContratoEdit(true)}
                      type="primary"
                      size="small"
                    >
                      Agregar Contrato
                    </Button>
                  )}
              </div>
            </div>
          ) : null}
        </Spin>
      </Header>
      <Content>
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Divider
            orientation="left"
            style={{ margin: '0 0 10px 0', flexShrink: 0 }}
          >
            Contrato
          </Divider>

          {!data?.contrato_unico ? (
            <div style={{ flex: 1, minHeight: 0 }}>
              <ContratoList />
            </div>
          ) : contratoList && contratoList.length > 0 ? (
            <div style={{ flex: 1, minHeight: 0 }}>
              <ContratoViewer contratoId={contratoList[0].id} />
            </div>
          ) : (
            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Empty description="No hay contrato cargado" />
            </div>
          )}
        </div>
      </Content>
      {showEdit && (
        <AlquilerEditor
          id={id2}
          parentId={id}
          onCancel={handleHideEditor}
          visible={true}
        />
      )}
      {showContratoEdit && (
        <ContratoEditor
          parentId={id2}
          onCancel={() => setShowContratoEdit(false)}
          visible={true}
        />
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { alquiler, contrato } = state;
  const stateData = alquiler;
  const contratoList = contrato.list?.data || [];
  return {
    stateData,
    contratoList,
  };
};

export default connect(mapStateToProps)(withRouter(AlquilerViewer));
